import { useRouter } from 'next/router';
import Link from 'next/link';

export default function NavLink({ href, children }) {
  const router = useRouter();
  const isActive = router.pathname.includes(href);
  const classNames = isActive ? 'text-blue-400' : 'text-gray-700';

  return (
    <Link href={href} className={`font-semibold text-xs lg:text-sm xl:text-base ${classNames}`}>
      {children}
    </Link>
  );
}
